/**
 * dealsApi — web wrapper, mirrors RN. Same surface as
 * `apps/WunderGuide/api/dealsApi.ts` — binds @wg/api/deals to the web's
 * authenticated httpClient and re-exports the platform-agnostic helpers.
 */
import {
  createDealsApi,
  formatDiscount,
  isExpiringSoon,
  getTimeRemaining,
} from '@wg/api/deals';
import type { DealsApi, DeviceType } from '@wg/api/deals';
import { httpClient } from '../http';
import logger from '../utils/logger';

const deviceType: DeviceType = 'web';

const dealsApi: DealsApi = createDealsApi(httpClient, logger, deviceType);

export default dealsApi;
export { formatDiscount, isExpiringSoon, getTimeRemaining };
export type { DealsApi };
